// eslint-disable-next-line import/prefer-default-export
export const getFormattedTimeStamp = (timestamp: number, toLocale = false) => {
  const toDate = new Date(timestamp);
  const date = toLocale ? toDate.toLocaleDateString() : toDate.toDateString();
  return date;
};
